if (!customElements.get('confirmation-popup')) {
  class ConfirmationPopup extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        closeHandler: '.js-close-confirmation-popup',

        confirmationPopupActiveClass: 'confirmation-popup--active',
      };

      this.closeHandler = this.querySelector(this.selectors.closeHandler);
    }

    connectedCallback() {
      this.closeHandler.addEventListener('click', this.closePopUp.bind(this));
    }

    disconnectedCallback() {
      this.closeHandler.removeEventListener('click', this.closePopUp.bind(this));
    }

    closePopUp() {
      this.classList.remove(this.selectors.confirmationPopupActiveClass);
    }
  }

  customElements.define('confirmation-popup', ConfirmationPopup);
}
